cb.define([], function () { 
  var AA_aa_settlemethodlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      var treeModel = viewmodel.get('aa_settlemethodlist');
      viewmodel.on('beforeAdd', function (args) {
        if (args.params.params && args.params.params.cParameter == 'child'
          && args.params.parent) {
          if (args.params.parent.level > 4) {
            cb.utils.alert('分类最多支持5级，已达到最大级次。', 'warning');
            return false;
          }
          //增加子类
          args.params.carryParams.id = args.params.parent.id;
        }
      });

      viewmodel.on('beforeBatchdelete', function (args) {
        let node = viewmodel.getTreeModel().getSelectedNodes()[0];
        if (!node.isEnd) {
          cb.utils.alert('存在下级，不能删除。', 'warning');
          return false;
        }
        return true;
      });

      const Ajax = (args, viewmodel) => {
        var proxy = cb.rest.DynamicProxy.create({
          ensure: {
            url: '/settlemethod/changeStatus',
            method: 'POST'
          }
        });
        let id = treeModel.getSelectedNodes()[0].id;
        let isEnabled;
        switch (args.cAction) {
          case "openaddress": // 启用
            isEnabled = true
            break;
          case "closeaddress": // 停用
            isEnabled = false
            break;
          default:
        }
        var params = {
          billnum: "aa_settlemethodlist",
          action: args.cAction,
          data: JSON.stringify({ id, isEnabled})
        }
        proxy.ensure(params, function(err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          cb.utils.alert(args.cShowCaption + '成功', 'success');
          viewmodel.execute('back')
        });
      }
      viewmodel.on('closesettlemethod', (args) => {
        Ajax(args, viewmodel)
      });
      viewmodel.on('opensettlemethod', (args) => {
        Ajax(args, viewmodel)
      });

      const setStatus = function(nodes, status){
        nodes.map(node => {
          if(node.level > 4){
            status.push({
              "key": node.id,
              "itemName": "btnAddChild",
              "name": "visible",
              "value": false
            });
          }

          if(!node.isEnd){// 非末级节点不能删除，不能停用,不能启用
            status.push({
              "key": node.id,
              "itemName": "btnDelete",
              "name": "visible",
              "value": false
            });
            status.push({
              "key": node.id,
              "itemName": "btnClose",
              "name": "visible",
              "value": false
            });
            status.push({
              "key": node.id,
              "itemName": "btnOpen",
              "name": "visible",
              "value": false
            });
            // if(!node.isEnabled) {//未启用节点不能停用
            //   status.push({
            //     "key": node.id,
            //     "itemName": "btnClose",
            //     "name": "visible",
            //     "value": false
            //   });
            // }
            // if(node.isEnabled) {//启用节点不能启用
            //   status.push({
            //     "key": node.id,
            //     "itemName": "btnOpen",
            //     "name": "visible",
            //     "value": false
            //   });
            // }
            
          } else {// 非末级节点
            if(node.isEnabled) { //启用的不可以删除、启用，可以停用
              status.push({
                "key": node.id,
                "itemName": "btnOpen",
                "name": "visible",
                "value": false
              });
              status.push({
                "key": node.id,
                "itemName": "btnDelete",
                "name": "visible",
                "value": false
              });
            }
            if (!node.isEnabled) {// 停用不可以停用
              status.push({
                "key": node.id,
                "itemName": "btnClose",
                "name": "visible",
                "value": false
              });
            }  
          }  
          
          if (node.sourcetype) {// 不能删除
            status.push({
              "key": node.id,
              "itemName": "btnDelete",
              "name": "visible",
              "value": false
            });
          } 

          if(node.children)
            setStatus(node.children, status)
        })
      }
      
      var treeModel = viewmodel.get('aa_settlemethodlist');
      treeModel.on('afterSetDataSource', function (data) {
        let status = []
        setStatus(data, status);
        treeModel.setActionsState(status);
      })
    }
  }
  try {
    module.exports = AA_aa_settlemethodlist_VM_Extend;
  } catch (error) {

  }
  return AA_aa_settlemethodlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_settlemethodlist_VM.Extend.js